/**
 * Generate a stable, locally-unique id. Prefers crypto.randomUUID when
 * available (modern browsers + Capacitor WebView); falls back to a
 * timestamp + random string for older runtimes.
 */
export function newId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return (
    Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
  );
}
